import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check_60290",
  "use": "check_60290-usage",
  "viewBox": "0 0 13 10",
  "content": "<symbol viewBox=\"0 0 13 10\" id=\"check_60290\">\n    <path d=\"M12.765 1.38L11.625.236a.775.775 0 0 0-.57-.236.775.775 0 0 0-.571.236l-5.502 5.53-2.466-2.483a.775.775 0 0 0-.57-.236.775.775 0 0 0-.57.236L.234 4.428A.78.78 0 0 0 0 5a.78.78 0 0 0 .235.572L3.27 8.62l1.14 1.144a.775.775 0 0 0 .57.236.776.776 0 0 0 .571-.236l1.14-1.144 6.073-6.095A.781.781 0 0 0 13 1.953a.781.781 0 0 0-.235-.573z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol